<template>
  <span class="font-poppins text-xs font-normal text-theme-pink">
    <slot></slot>
  </span>
</template>
